const styles = {
    box: {
        backgroundColor: 'white',
        position: 'absolute',
        zIndex: '500',
        height: '550px',
        borderRadius: '5px 0px 0px 5px',
        borderLeft: '1px solid #888',
        borderTop: '1px solid #888',
        borderBottom: '1px solid #888',
    },
    boxTableProps: {
        backgroundColor: 'white',
        position: 'absolute',
        zIndex: '200',
        height: '350px',
        borderRadius: '5px 0px 0px 5px',
        borderLeft: '1px solid #888',
        borderTop: '1px solid #888',
        borderBottom: '1px solid #888',
    },
    slider: {
        margin: '10px 0px',
    },
    sliderDot: {
        height: '10px',
        width: '10px',
        border: '1px',
    },
    layerPropsUpdateButton: {
        bottom: '2px',
        margin: '6px',
        right: '90px',
        position: 'absolute',
    },
    layerPropsCloseButton: {
        bottom: '2px',
        right: '2px',
        margin: '6px',
        position: 'absolute',
    },
    metadataContainer: {
        marginLeft: 20,
        marginRight: 'auto',
    },
    leftCellHead: {
        textAlign: 'left',
    },
    colorLabel: {
        float: 'left',
        marginLeft: '5%',
    },
    colorBoxLeft: {
        float: 'right',
        marginRight: '5%',
    },
    colorBoxRight: {
        float: 'right',
    },
    generateButton: {
        width: '50%',
    },
    generateCell: {
        textAlign: 'center',
        // width: '50%',
    },
    tableItem: {
        textAlign: 'center',
    },
    tableContainer: {
        overflow: 'auto',
        maxHeight: '140px',
    },
    symbologyTab: {
        // textAlign: center,
    },
    symTableHead: {
        marginTop: '40px',
        width: '100%',
        borderCollapse: 'collapse',
    },
    symTable: {
        width: '100%',
        borderCollapse: 'collapse',
    },
    symTableCellCenter: {
        textAlign: 'center',
        border: '1px solid #ccc',
        margin: '0px',
    },
    symTableCellLeft: {
        borderLeft: '1px solid #ccc',
        borderRight: '1px solid #ccc',
        borderTop: '1px solid #ccc',
        borderBottom: '1px solid #ccc',
        margin: '0px',
        textAlign: 'center',
    },
    symTableCellRight: {
        textAlign: 'center',
        borderLeft: '1px solid #ccc',
        borderRight: '1px solid #ccc',
        borderTop: '1px solid #ccc',
        borderBottom: '1px solid #ccc',
        margin: '0px',
    },
    inputStyle: {
        width: '90%',
    },
    labelSpacer: {
        width: '14%',
    },
    symbolLabel: {
        width: '1%',
    },
    tabLabel: {
        fontSize: 'large',
    },
    tableLabel: {
        width: '43%',
    },
    paramLabel: {
        display: 'inline-block',
        minWidth: '120px',
    },
    paramValue: {
        display: 'inline-block',
        marginLeft: 10,
    },
    sectionLabel: {
        fontSize: 'larger',
        margin: '10px 0px 10px 0px',
        // borderBottom: '1px solid #ccc',
        textAlign: 'center',
    },
    extentTable: {
        textAlign: 'center',
        width: '100%',
    },
    fieldset: {
        margin: '20px 0px 10px 0px',
        borderRadius: '5px',
        borderColor: '#fff',
    },
    metadataItem: {
    },
    layerPropsTable: {
        marginLeft: 'auto',
        marginRight: 'auto',
    },
    tag: {
        margin: '5px',
    },
    tagBox: {
        marginTop: '10px',
        width: '400px',
        maxHeight: '200px',
        overflow: 'auto',
    },
    userMetadata: {
        marginLeft: 20,
        maxHeight: 200,
        overflow: 'auto',
    },
}

export default styles
